<template>
  <AsyncModal
    :fetch="fetchAccessoryExclusions"
    :name="MODAL_NAMES.EXCLUDED_ACCESSORIES"
    :title="modalTitle"
  >
    <template #content>
      <ExcludedAccessoriesModal
        v-if="accessoryExclusions"
        :accessory-exclusions
      />
    </template>
  </AsyncModal>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import AsyncModal from '@backmarket/nuxt-layer-product-modals/AsyncModal.vue'

import type { GetAccessoryExclusionsResponse } from '~/api/product-page/types'
import { MODAL_NAMES } from '~/scopes/product/constants'
import ExcludedAccessoriesModal from '~/scopes/product-core/components/presentationals/Accessories/components/ExcludedAccessoriesModal/ExcludedAccessoriesModal.vue'
import { useFetchAccessoryExclusions } from '~/scopes/product-core/composables/useFetch/useFetchAccessoryExclusions/useFetchAccessoryExclusions'

const accessoryExclusions = ref<GetAccessoryExclusionsResponse | undefined>(
  undefined,
)

async function fetchAccessoryExclusions() {
  const { data } = await useFetchAccessoryExclusions()
  accessoryExclusions.value = data.value
}

const modalTitle = computed(() => accessoryExclusions.value?.title ?? '')
</script>
